module.exports = __webpack_public_path__ + "img/P150T_weapon_2.9d68c9dc.png";